// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".eDvIPXGjzBdiaB {\n  height: 100%;\n  position: relative;\n  z-index: 0;\n}\n.u0A99dvH8I2WI5 {\n  left: 0;\n  position: absolute;\n  top: 0;\n  z-index: 80;\n}\n._6AlhffB4xjal5- {\n  position: fixed;\n  right: 4px;\n  top: 40px;\n  z-index: 2;\n  max-width: 270px;\n}\n.ow8Y0hnU8gfnGT {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  z-index: 100;\n}\n.GvTCHDqTRJIsS\\+ {\n  left: 0;\n  position: absolute;\n  top: 0;\n  z-index: 70;\n}\n.hveOSSdKetN4rf {\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: 4;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appLayer": "eDvIPXGjzBdiaB",
	"overlayLayer": "u0A99dvH8I2WI5",
	"alertLayer": "_6AlhffB4xjal5-",
	"flagLayer": "ow8Y0hnU8gfnGT",
	"popoverLayer": "GvTCHDqTRJIsS+",
	"tooltipLayerRef": "hveOSSdKetN4rf"
};
export default ___CSS_LOADER_EXPORT___;
